import { Box, Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSIconCard from "../../Components/IconCard/WSIconCard";
import { useNavigate } from "react-router-dom";
import { Course } from "./Course";  // Import your Course component
import { SeatNumberModal } from "./SeatNo";
import { CardProcessing } from "./CardProcessing";
import KOTDialog from "./KOTDialogue";
import { GroupTagFilter } from "./GroupTagFilter";
import { SurCharge } from "./Surcharge";

interface FooterDialogProps {
  open: boolean;
  onClose: () => void;
}

export const ReceiptOperation: React.FC<FooterDialogProps> = React.memo(({ open, onClose }) => {
  const navigate = useNavigate();
  const [openCourseDialog, setOpenCourseDialog] = useState(false);  
  const [openSeatNoDialog, setOpenSeatNoDialog] = useState(false);  
  const [openCardProcessing, setOpenCardProcessing] = useState(false);  
  const [openKOT, setOpenKOT] = useState(false);  
  const [openGroupTagFilter, setOpenGroupTagFilter] = useState(false);  
  const [openSurcharge, setOpenSurcharge] = useState(false);  

  const handleClick = (path: string) => {
    navigate(path);
  };
/**
 * Course Dialogue
 */
  const handleCourseClick = () => {
    onClose();                
    setOpenCourseDialog(true); 
  };

  const handleCourseClose = () => {
    setOpenCourseDialog(false); 
  };

  /**
   * Seat no dialogue
   */
  const handleSeatNoClick = () => {
    onClose();                
    setOpenSeatNoDialog(true); 
  };

  const handleSeatNoClose = () => {
    setOpenSeatNoDialog(false); 
  };
/**
 * Loyalty dialogue
 */
  const handleLoyaltyClick = () => {
    onClose();                
    setOpenCardProcessing(true); 
  };
  const handleCardProcessingClose = () => {
    setOpenCardProcessing(false); 
  };
  /**
   * Kot dialogue
   */
  const handleKOTClick = () => {
    onClose();               
    setOpenKOT(true); 
  };
  const handleKOTClose = () => {
    setOpenKOT(false); 
  };
  /**
   * GroupTag dialogue
   */
  const handleGroupTagClick = () => {
    onClose();                
    setOpenGroupTagFilter(true); 
  };
  const handleGroupTagFilterClose = () => {
    setOpenGroupTagFilter(false); 
  };
  /**
   * surcharge
   */
  const handleSurchargeClick = () => {
    onClose();                
    setOpenSurcharge(true); 
  };
  const handleSurchargeClose = () => {
    setOpenSurcharge(false); 
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            display: 'flex',
            justifyContent: 'center',
            margin: 0,  // Remove margin around the dialog
          },
        }}>
        <DialogTitle sx={{ padding: 0 }}>
          <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: "green" }}>
              Receipt Operation
            </Typography>
            <Grid sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <WSIcons.GTranslateIcon />
              <IconButton onClick={onClose}>
                <WSIcons.CloseIcon sx={{ backgroundColor: 'red', color: 'white' }} />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <WSIconCard icon={<WSIcons.SearchIcon sx={{ color: "green" }} />} name={"Item Search"} sx={{ width: "11rem" }} onClick={() => handleClick('/itemsearch')} />
            </Grid>
            <Grid item xs={3}>
              <WSIconCard icon={<WSIcons.SoupKitchenIcon sx={{ color: "green" }} />} name={"Course"} sx={{ width: "11rem" }} onClick={handleCourseClick} />
            </Grid>
            <Grid item xs={3}>
              <WSIconCard icon={<WSIcons.Chair sx={{ color: "green" }} />} name={"Seat No"} sx={{ width: "11rem" }} onClick={handleSeatNoClick} />
            </Grid>
            <Grid item xs={3}>
              <WSIconCard icon={<WSIcons.Tag sx={{ color: "green" }} />} name={"Complimentary Item"} sx={{ width: "11rem" }} />
            </Grid>
            <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.RoomServiceIcon sx={{color:"green"}}/>} name={"Hold Item"} sx={{width:"11rem"}} />
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.FireplaceIcon sx={{color:"green"}}/>} name={"Fire Item"} sx={{width:"11rem"}} />
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.Hold sx={{color:"green"}}/>} name={"Hold Order"} sx={{width:"11rem"}} />
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.PrintIcon sx={{color:"green"}}/>} name={"Change Printing Template"} sx={{width:"11rem"}} />
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.MessageIcon sx={{color:"green"}}/>} name={"Pantry Message"} sx={{width:"11rem"}} />
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.Modification sx={{color:"green"}}/>} name={"Modification"} sx={{width:"11rem"}} onClick={()=>handleClick('/modification')}/>
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.LoyaltyIcon sx={{color:"green"}}/>} name={"Loyalty"} sx={{width:"11rem"}} onClick={handleLoyaltyClick}/>
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.ReceiptLongIcon sx={{color:"green"}}/>} name={"Assign kot"} sx={{width:"11rem"}} onClick={handleKOTClick}/>
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.FilterAltIcon sx={{color:"green"}}/>} name={"Group Tag Filter"} sx={{width:"11rem"}} onClick={handleGroupTagClick}/>
          </Grid>
          <Grid item xs={3}>
            <WSIconCard icon={<WSIcons.Surcharge sx={{color:"green"}}/>} name={"Surcharge"} sx={{width:"11rem"}} onClick={handleSurchargeClick}/>
          </Grid>          
          </Grid>
        </DialogContent>
      </Dialog>
      <Course open={openCourseDialog}  onClose={handleCourseClose} />
      <SeatNumberModal open={openSeatNoDialog}  onClose={handleSeatNoClose}/>
      <CardProcessing open={openCardProcessing}  onClose={handleCardProcessingClose} />
      <KOTDialog open={openKOT}  onClose={handleKOTClose} />
      <GroupTagFilter open={openGroupTagFilter}  onClose={handleGroupTagFilterClose} />
      <SurCharge open={openSurcharge}  onClose={handleSurchargeClose} />

    </>
  );
});
